import React from "react"
import { InputAdornment, ListSubheader, MenuItem, OutlinedInput, Select, TextField } from "@mui/material"
import { useMemo } from "react"
import SearchIcon from "@mui/icons-material/Search"

const SelectWithSearchInput = ({
  id,
  name,
  placeholder,
  value,
  style,
  disabled = false,
  defaultValue,
  handleOnChangeSelect,
  optionsList = [],
  showSearchBar = true,
  searchText,
  setSearchText,
  inputStyle,
  menuListStyle = {},
}) => {
  const currentOptionsList = useMemo(
    () => optionsList.filter(item => item?.title?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1),
    [optionsList, searchText]
  )

  return (
    <Select
      id={id}
      value={value}
      className="mb-0 mt-n1 form-input-align form-control flex-column form-group col-lg-16 form-control"
      label=""
      displayEmpty
      name={name}
      disabled={disabled}
      style={{
        paddingRight: 0,
        paddingLeft: "2em",
        lineHeight: "0.4375em",
        borderRadius: "40px",
        ...style,
      }}
      MenuProps={{
        sx: {
          "& .MuiMenu-list": {
            ...menuListStyle,
          },
        },
      }}
      sx={{
        "& .MuiInputBase-input": {
          ...inputStyle,
          paddingTop: "13px",
        },
        "& .MuiSelect-outlined:has(span)": {
          paddingTop: "7px",
          paddingBottom: "7px"
        }
      }}
      defaultValue={defaultValue}
      onClose={() => setSearchText && setSearchText("")}
      onChange={handleOnChangeSelect}
      input={<OutlinedInput />}
      renderValue={(selected) => {
        if (!selected) {
          return <span className="form-control_caption">{placeholder}</span>;
        }
        const itemTitle = currentOptionsList?.find(option => option.value === value)?.title
        return itemTitle;
      }}
    >
      {showSearchBar && setSearchText && (
        <ListSubheader>
          <TextField
            size="small"
            autoFocus
            placeholder={placeholder}
            fullWidth
            onBlur={e => e.target.focus()}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={e => setSearchText(e.target.value)}
            onKeyDown={e => {
              if (e.key !== "Escape") {
                e.stopPropagation()
              }
            }}
          />
        </ListSubheader>
      )}
      {currentOptionsList?.map(item => (
        <MenuItem key={item.value} value={item.value} title={item.title}>
          {item.title}
        </MenuItem>
      ))}
    </Select>
  )
}

export default SelectWithSearchInput
